var chunkMapping = {
	"371": [
		80371
	],
	"1959": [
		31959
	],
	"3093": [
		13093
	],
	"3167": [
		83167
	],
	"3973": [
		43973
	],
	"4236": [
		74236
	],
	"4495": [
		24495
	],
	"4805": [
		74805
	],
	"4873": [
		54873
	],
	"5258": [
		15258
	],
	"5705": [
		95705
	],
	"6538": [
		54157
	],
	"6544": [
		26544
	],
	"6569": [
		76569
	],
	"7282": [
		97282
	],
	"7868": [
		47868
	],
	"9309": [
		89309
	],
	"9378": [
		59378
	]
};
var idToExternalAndNameMapping = {
	"13093": [
		"default",
		"./ConversationAuditFooter",
		85817
	],
	"15258": [
		"default",
		"./Conversations",
		85817
	],
	"24495": [
		"default",
		"./Replay",
		85817
	],
	"26544": [
		"default",
		"./KnowledgeBases",
		85817
	],
	"31959": [
		"default",
		"./Integrations",
		85817
	],
	"43973": [
		"default",
		"./AiTaggingAndFieldFilling",
		85817
	],
	"47868": [
		"default",
		"./Styles",
		85817
	],
	"54157": [
		"default",
		"./Settings",
		85817
	],
	"54873": [
		"default",
		"./Tags",
		85817
	],
	"59378": [
		"default",
		"./McpServers",
		85817
	],
	"74236": [
		"default",
		"./Agents",
		85817
	],
	"74805": [
		"default",
		"./Playground",
		85817
	],
	"76569": [
		"default",
		"./ConversationFilterPanel",
		85817
	],
	"80371": [
		"default",
		"./ControlledFlows",
		85817
	],
	"83167": [
		"default",
		"./Tools",
		85817
	],
	"89309": [
		"default",
		"./CreateProject",
		85817
	],
	"95705": [
		"default",
		"./Improvements",
		85817
	],
	"97282": [
		"default",
		"./SmartAudit",
		85817
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}